jQuery($ => {

  if($('.m-filters')[0]){
    $('.a-select__native').on('change', function() {
      const $form = $('.m-filters__form');

      $form.submit();
    });
  }

});